import State, { CreditAppSettings } from "Types/creditApp";
import baseReducer from "./base";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import {
    getCreditAppSettingsRequest,
    getCreditAppSettingssFailure,
    getCreditAppSettingsSuccess,
} from "src/store/actions/creditApp/settings";

const creditApp = (state: any = {}, action: any): State => ({
    base: baseReducer(state.base, action, state),
    settings: settingsReducer(state.settings, action, state),
});

type CreditAppSettingsActions =
    | ActionType<typeof getCreditAppSettingsRequest>
    | ActionType<typeof getCreditAppSettingsSuccess>
    | ActionType<typeof getCreditAppSettingssFailure>;

const settingsReducer = (state: CreditAppSettings = {}, action: CreditAppSettingsActions, creditAppState: State) => {
    switch (action.type) {
        case getCreditAppSettingsRequest.type:
            return { status: "loading" as const };
        case getCreditAppSettingsSuccess.type:
            return { status: "loaded" as const, ...action.payload.settings };
        case getCreditAppSettingssFailure.type:
            return { status: "failure" as const };
        default:
            return state;
    }
};

export default creditApp;
